import React from 'react'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

import PopUp from 'reusableComponents/PopUp/PopUp'
import { ReactComponent as LocationDot } from 'assets/svg/location-dot.svg'
import { colors } from 'globalStyles'

import styled from 'styled-components'
import { Button } from 'react-bootstrap'

const AddressText = styled.div`
  margin-bottom: 8px;
  font-size: 16px;
  color: ${colors.web_text_black};
`

const IncorrectAddressLink = styled.a`
  color: ${colors.text_link};
  text-decoration: underline;
  cursor: pointer;
  font-size: 14px;
  display: inline-block;
  margin-bottom: 16px;
`

const TitleContainer = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
`

const IconStyle = styled(LocationDot)`
  width: 24px;
  height: 24px;
  margin-right: 6px;
`

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`

const AddressContainer = styled.div`
  margin-bottom: 16px;
`
const DeliveryAddressPopUp = ({
  show,
  onHide,
  address,
  onIncorrectAddressClick,
  allowAddressCorrection,
  addressCorrectionRequest,
}) => {
  const { t } = useTranslation()
  return (
    <PopUp
      show={show}
      onHide={onHide}
      title={
        <TitleContainer>
          <IconStyle />
          {t('del_date_addr_correction.delivery_address')}
        </TitleContainer>
      }
      primaryButton={
        <ButtonContainer>
          <Button variant="primary" onClick={onHide}>
            {t('buttonActions.close')}
          </Button>
        </ButtonContainer>
      }
      secondaryButton={null}
    >
      <AddressText>{address}</AddressText>
      {allowAddressCorrection && !addressCorrectionRequest && (
        <AddressContainer>
          <IncorrectAddressLink onClick={onIncorrectAddressClick} tabIndex={0} role="button">
            {t('del_date_addr_correction.incorrect_address')}
          </IncorrectAddressLink>
        </AddressContainer>
      )}
    </PopUp>
  )
}

DeliveryAddressPopUp.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  address: PropTypes.string.isRequired,
  onIncorrectAddressClick: PropTypes.func,
  allowAddressCorrection: PropTypes.bool,
  addressCorrectionRequest: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
}

DeliveryAddressPopUp.defaultProps = {
  onIncorrectAddressClick: () => {},
  allowAddressCorrection: false,
  addressCorrectionRequest: null,
}

export default DeliveryAddressPopUp
